import { render } from "./DefaultLessonPage.vue?vue&type=template&id=4f79b98c&scoped=true"
import script from "./DefaultLessonPage.vue?vue&type=script&lang=js"
export * from "./DefaultLessonPage.vue?vue&type=script&lang=js"

import "./DefaultLessonPage.vue?vue&type=style&index=0&id=4f79b98c&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f79b98c"]])

export default __exports__